// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";

function titleCmpDecoder(json) {
  return {
          title_prefix: Json_decode.field("title_prefix", Json_decode.string, json),
          title_suffix: Json_decode.field("title_suffix", Json_decode.string, json),
          title_header: Json_decode.field("title_header", Json_decode.string, json)
        };
}

function claimRewardDecoder(json) {
  return {
          title: Json_decode.field("title", Json_decode.string, json),
          login_hours_display_text: Json_decode.field("login_hours_display_text", Json_decode.string, json),
          order_fulfillment_display_text: Json_decode.field("order_fulfillment_display_text", Json_decode.string, json),
          order_rating_display_text: Json_decode.field("order_rating_display_text", Json_decode.string, json),
          footer_text: Json_decode.field("footer_text", Json_decode.string, json)
        };
}

function execute(json) {
  return {
          title_cmp: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "rnr_claim_reward",
                      tl: {
                        hd: "title_cmp",
                        tl: /* [] */0
                      }
                    }
                  }
                }, titleCmpDecoder)(json),
          claim_reward_table: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "rnr_claim_reward",
                      tl: {
                        hd: "claim_reward_table",
                        tl: /* [] */0
                      }
                    }
                  }
                }, claimRewardDecoder)(json)
        };
}

export {
  titleCmpDecoder ,
  claimRewardDecoder ,
  execute ,
  
}
/* No side effect */
